module.exports = __webpack_public_path__ + "77aca1962bc15463b1638c435caa13ac.jpg";